export const GET_MACHINERY_HISTORY_LIST =
  '/machinery_history/GET_MACHINERY_HISTORY_LIST';
export const GET_SINGLE_HISTORY = '/machinery_history/GET_SINGLE_HISTORY';
export const GET_MACHINERY_APPRAISAL_HISTORY_LIST =
  '/machinery_history/GET_MACHINERY_APPRAISAL_HISTORY_LIST';
export const GET_MACHINERY_PROPERTY_ASSESSMENT_HISTORY_LIST =
  '/machinery_history/GET_MACHINERY_PROPERTY_ASSESSMENT_HISTORY_LIST';
export const GET_MACHINERY_RECORD_OF_SUP_ASSESSMENT_HISTORY_LIST =
  '/machinery_history/GET_MACHINERY_RECORD_OF_SUP_ASSESSMENT_HISTORY_LIST';
export const GET_MACHINERY_TRANSACTION_HISTORY_LIST =
  '/machinery_history/GET_MACHINERY_TRANSACTION_HISTORY_LIST';

export const FAAS_URL =
  'api/v1/rpt/administrator/machineries/machinery_applications/{applicationId}/machinery_history_logs/{historyId}/faas';
export const TAX_DECLARATION_URL =
  'api/v1/rpt/administrator/machineries/machinery_applications/{applicationId}/machinery_history_logs/{historyId}/tax_declaration';

// for modal

export const GET_MACHINERY_APPRAISAL = '/land/get_machinery_appraisal';
export const GET_SINGLE_MACHINERY_APPRAISAL =
  '/land/get_single_machinery_appraisal';
export const CREATE_MACHINERY_APPRAISAL = '/land/create_machinery_appraisal';
export const UPDATE_MACHINERY_APPRAISAL = '/land/update_machinery_appraisal';
export const REMOVE_MACHINERY_APPRAISAL = '/land/remove_machinery_appraisal';

export const GET_MACHINERY_PROPERTY_ASSESSMENT =
  '/land/get_machinery_property_assessment';
export const GET_SINGLE_MACHINERY_PROPERTY_ASSESSMENT =
  '/land/get_single_machinery_property_assessment';
export const CREATE_MACHINERY_PROPERTY_ASSESSMENT =
  '/land/create_machinery_property_assessment';
export const UPDATE_MACHINERY_PROPERTY_ASSESSMENT =
  '/land/update_machinery_property_assessment';
export const REMOVE_MACHINERY_PROPERTY_ASSESSMENT =
  '/land/remove_machinery_property_assessment';

export const GET_MACHINERY_RECORD_OF_SUP_ASSESSMENT =
  '/land/get_machinery_record_of_sup_assessment';
export const GET_SINGLE_MACHINERY_RECORD_OF_SUP_ASSESSMENT =
  '/machinery/get_single_machinery_record_of_sup_assessment';
export const CREATE_MACHINERY_RECORD_OF_SUP_ASSESSMENT =
  '/machinery/create_machinery_record_of_sup_assessment';
export const UPDATE_MACHINERY_RECORD_OF_SUP_ASSESSMENT =
  '/machinery/update_machinery_record_of_sup_assessment';
export const REMOVE_MACHINERY_RECORD_OF_SUP_ASSESSMENT =
  '/machinery/remove_machinery_record_of_sup_assessment';

export const GET_MACHINERY_TRANSACTION = '/machinery/get_machinery_transaction';

export const GET_LAND_CLASSIFICATIONS = '/land/get_land_classifications';
export const GET_SINGLE_LAND_CLASS = '/land/get_single_land_class';

export const GET_TRANSACTION_CODES = '/get_transaction_codes';

export const GET_LAND_OWNER = '/get_land_owner';
export const GET_SINGLE_LAND_OWNER = '/get_single_land_owner';
export const GET_BUILDING_OWNER = '/get_building_owner';
export const GET_SINGLE_BUILDING_OWNER = '/get_single_building_owner';
export const GET_MACHINERY_OWNER = '/get_machinery_owner';
export const GET_SINGLE_MACHINERY_OWNER = '/get_single_machinery_owner';

export const GET_PROVINCE = '/get_provinces';
export const GET_MUNICIPALITIES = '/get_municipalities';
export const GET_BARANGAYS = '/get_barangays';

export const FORM_DATA = {
  rptax_transaction_code_id: '',
  rptax_owner_id: '',
  tdn: '',
  property_location_brgy_district: '',
  property_location_municipality: '',
  property_location_no_street: '',
  property_location_province_city: '',
  property_location_brgy_district_code: '',
  property_location_municipality_code: '',
  property_location_province_city_code: '',
  property_boundaries_north: '',
  property_boundaries_east: '',
  property_boundaries_south: '',
  property_boundaries_west: '',
  property_boundaries_land_sketch_photo_url: '',
  arp_no: '',
  pin: '',
  oct_tct_cloa_no: '',
  oct_tct_cloa_dated: '',
  survey_no: '',
  lot_no: '',
  blk: '',
  administrator_beneficial_user: '',
  administrator_beneficial_address: '',
  administrator_beneficial_telephone_no: '',
  administrator_beneficial_tin: '',
  effectivity_of_assessment_reassessment_qtr: '',
  effectivity_of_assessment_reassessment_yr: '',
  appraised_assessed_by: '',
  appraised_assessed_at: '',
  recommending_by: '',
  recommending_at: '',
  approved_by: '',
  approved_at: '',
  memoranda: '',
};

export const LAND_APPRAISAL_FORM_DATA = {
  rptax_land_classification_id: '',
  rptax_land_sub_classification_id: '',
  rptax_actual_use_id: '',
  area: '',
  classification: '',
  sub_classification: '',
  actual_use: '',
};

export const LAND_PROPERTY_ASSESSMENT_FORM_DATA = {
  actual_use: '',
};

export const LAND_MARKET_VALUE_FORM_DATA = {
  rptax_land_adjustment_factor_id: '',
  adjustment_factor: '',
};

export const LAND_SUP_ASSESSMENT_FORM_DATA = {
  pin: '',
  arp_no: '',
  td_no: '',
  total_assessed_value: '',
  previous_owner: '',
  effectivity_of_assessment: '',
  ar_page_no: '',
  recording_person: '',
  date: '',
};
